import { useCallback, useEffect } from "react";
import { analytics, AnalyticsEventEmitter, FileType, PlaybackState, Topic, usePlaybackStateStore, } from "@annunciate/core";
export const useEbookPlaybackState = () => {
    const handleChange = useCallback(async (playerIndex) => {
        const { setState, content } = usePlaybackStateStore.getState();
        if (!content || content.asset?.type !== FileType.EBOOK)
            return;
        if (playerIndex === 1) {
            await analytics.emitPlaybackEvent("resumed");
            await analytics.emitEbookEvent("playing", content);
            setState(content.id, PlaybackState.PLAYING);
        }
        else if (playerIndex === 0) {
            await analytics.emitPlaybackEvent("paused");
            await analytics.emitEbookEvent("pausing", content);
            setState(content.id, PlaybackState.STOPPED);
        }
    }, []);
    const handleBackgrounded = useCallback(async () => {
        const playerIndex = usePlaybackStateStore.getState().playerIndex;
        if (playerIndex !== 1)
            return;
        await handleChange(0);
        return;
    }, [handleChange]);
    const handleForgrounded = useCallback(async () => {
        const playerIndex = usePlaybackStateStore.getState().playerIndex;
        if (playerIndex !== 1)
            return;
        await handleChange(playerIndex);
        return;
    }, [handleChange]);
    useEffect(() => {
        const unsubscribe = usePlaybackStateStore.subscribe((state) => state.playerIndex, (playerIndex) => handleChange(playerIndex));
        AnalyticsEventEmitter.on(Topic.APP_BACKGROUNDED, handleBackgrounded);
        AnalyticsEventEmitter.on(Topic.APP_FOREGROUNDED, handleForgrounded);
        return () => {
            unsubscribe();
            AnalyticsEventEmitter.off(Topic.APP_BACKGROUNDED, handleBackgrounded);
            AnalyticsEventEmitter.off(Topic.APP_FOREGROUNDED, handleForgrounded);
        };
    }, []);
    return;
};
//# sourceMappingURL=useEbookPlaybackState.js.map